<template>

	<div class="tab-son" @click="itemclick">
		<div :class="{vactive:isactive}" class="tab-box">
			<slot name="item-txt">
			</slot>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'tabitem',
		data() {
			return {
				// isactive: false
				paths: '',
				biaoshis: '',
			}
		},
		props: {
			link: String,
			biaoshi: String
		},
		created() {

		},
		computed: {
			isactive() {
				let that = this;
				that.paths = that.$route.path
				if (that.biaoshi == '') {
					that.$emit("routerpath", this.paths)
				return that.$route.path.indexOf(this.link) !== -1
				} else{
					that.$emit("routerpath", this.paths)
				return  that.$route.query.label === that.biaoshi
				}
				

			}
		},
		methods: {
			itemclick() {

				// this.$router.replace(this.link)
			// this.$router.push({
			// 	path: this.link,
			// 	target:'_blank',
			// });
			window.open(this.link);


			}
		},
	}
</script>
<style scoped>
	.tab-son {
		box-sizing: border-box;
		text-align: center;
		height: 60px;
		font-size: 20px;
	}
	
	.tab-box {
		padding: 0 45px;
	}
	
	.tab-box div {
		line-height: 60px;
		height: 60px;
	}
	
	.vactive {
		background-color: #bd182a;
	}
</style>